<libero-blog-full-article-content
  [articleDetail]="articleDetail"
  [errored]="errored"
  [loading]="loading"
  [showOtherPosts]="false"
  data-cy="blog-preview"
></libero-blog-full-article-content>